module.exports = __webpack_public_path__ + "static/media/secrets_shared.4e58ef1e.png";